import CalculatorPage from "../../pages/CalculatorPage";
import LandingPage from "../../pages/LandingPage";
import NotFoundPage2 from "../../pages/NotFoundPage";

const isUnderMaintenance = true;
const pathRoot = process.env.REACT_APP_MCC_ROOT;
const maintenanceRoot = isUnderMaintenance ? `${pathRoot}-wip` : '';

export const NAV_CONFIG_APP = {
    rootPath: pathRoot,
    routes:
    [
        {
            title: 'Home',
            path: pathRoot,
            element: <LandingPage />,
        },
        {
            title: 'Calculator',
            path: pathRoot + '/calculator',
            element: <CalculatorPage />,
        },
        {
            isHidden: true,
            path: pathRoot + "/*",
            element: <NotFoundPage2 />,
        },
    ]
}
